// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__Obv4k","label":"LabeledBox_label__2vxNm"};